module.exports = __webpack_public_path__ + "static/media/logo_panel-black.16ff90b2.svg";